var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 5H11.25",
    stroke: "#CCCFD1",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 7.5H11.25",
    stroke: "#CCCFD1",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 10H11.25",
    stroke: "#CCCFD1",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54965 10.933V3.76165C4.54965 3.53789 4.63924 3.3233 4.7987 3.16508C4.95817 3.00686 5.17446 2.91797 5.39999 2.91797H7.10067C7.32619 2.91797 7.54248 3.00686 7.70195 3.16508C7.86142 3.3233 7.95101 3.53789 7.95101 3.76165V10.933C8.57919 11.3027 9.06759 11.8669 9.34111 12.5389C9.61463 13.2109 9.65813 13.9534 9.46492 14.6522C9.27171 15.3511 8.85249 15.9677 8.2717 16.4071C7.69092 16.8466 6.98073 17.0846 6.25033 17.0846C5.51992 17.0846 4.80973 16.8466 4.22895 16.4071C3.64816 15.9677 3.22894 15.3511 3.03573 14.6522C2.84252 13.9534 2.88602 13.2109 3.15954 12.5389C3.43306 11.8669 3.92146 11.3027 4.54965 10.933Z",
    stroke: "#CCCFD1",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 3.91797C4.58301 3.36568 5.03072 2.91797 5.58301 2.91797H6.91634C7.46863 2.91797 7.91634 3.36568 7.91634 3.91797V7.08464H4.58301V3.91797Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemperature);
export default __webpack_public_path__ + "static/media/icon-temperature.57a7ab0cb7e2c2fa0761a48e00d57286.svg";
export { ForwardRef as ReactComponent };